import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FakeData } from '../../core/_models';

@Component({
  selector: 'common-airline-general-information-popup',
  templateUrl: './airline-general-information-popup.component.html',
  styleUrls: ['./airline-general-information-popup.component.scss'],
  standalone: false,
})
export class AirlineGeneralInformationPopupComponent {
  @Input() data: FakeData;

  constructor(public activeModal: NgbActiveModal) {}

  closeModal() {
    this.activeModal.dismiss();
  }

  get hasAirlinetaxes(): boolean {
    return (
      this.data.taxes?.ams?.length > 0 ||
      this.data.taxes?.cca?.length > 0 ||
      this.data.taxes?.chc?.length > 0 ||
      this.data.taxes?.ecs?.length > 0 ||
      this.data.taxes?.fhl?.length > 0 ||
      this.data.taxes?.fwb?.length > 0 ||
      this.data.taxes?.pod?.length > 0 ||
      this.data.taxes?.rac?.length > 0 ||
      this.data.taxes?.saf?.length > 0
    );
  }

  getFuelSurcharge(data): string {
    if (!data.fuelSurcharge) {
      return 'Included';
    }
    return data.fuelSurcharge + ' ' + data.currency + '/KG';
  }

  getSecuritySurcharge(data): string {
    if (!data.securitySurcharge) {
      return 'Included';
    }
    return data.securitySurcharge + ' ' + data.currency + '/KG';
  }

  getMiscellaneousSurcharge(data): string {
    if (!data.miscellaneousCharge) {
      return 'Included';
    }
    return data.miscellaneousCharge + ' ' + data.currency + '/KG';
  }

  get hasGHAtaxes(): boolean {
    return this.data.taxes?.dfc?.length > 0 || this.data.taxes?.scc?.length > 0;
  }

  get hasOtherOCDCtaxes(): boolean {
    return this.data.taxes?.otherOcdc?.length > 0;
  }
}
